module.exports = __webpack_public_path__ + "static/media/logoSpade.ddfe498b.svg";